import { formatAndBindToJSONToDayjs } from "../../utils/common"
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(timezone)

const endDate = dayjs(); 
const startDate = endDate.clone().subtract(5, 'minutes'); 
const formattedEndDate = formatAndBindToJSONToDayjs(endDate, "current")
const formattedStartDate = formatAndBindToJSONToDayjs(startDate, "current");

const states = {
  campaigns_analytics_details: {
    historicMetrics: {
      metrics: [],
      graphs: [],
      tables: []
    },
    liveMetrics: {
      metrics: [],
      tables: [],
    },
    selectedDateRange: [formattedStartDate, formattedEndDate],
    granularity: "auto",
    selectedCampaignIds: [],
    loading: false,
    lLoadError: false,
    hLoadError: false,
    sLoadError: false,
    cLoadError: false,
    hLoading: false,
    sLoading: false,
    cLoading: false,
    loadError: false
  },
}

export default states